export default __webpack_public_path__ + "static/Data-Engineering-e7b6210f971761a7f8e4b2f521eeac14.webp";